exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._32hzc{display:flex;flex-direction:column-reverse;width:180px;height:90px;border:2px solid rgba(0,0,0,0.5);border-radius:2px;background-color:rgba(0,0,0,0.5);align-items:center}._32hzc.p6mWy{width:initial;height:initial;border:none;border-radius:0}._1nIt3,._4tyZ-{position:absolute;top:2px;right:2px;bottom:2px;left:2px;width:180px;height:90px}._1nIt3{z-index:2}._4tyZ-{z-index:1}.p6mWy ._24WRk{background:none}.p6mWy ._1nIt3,.p6mWy ._4tyZ-{width:0;height:0}._24WRk{font-size:11px;line-height:12px;position:relative;z-index:3;padding:4px 5px;white-space:nowrap;color:white;background:rgba(0,0,0,0.8)}\n", ""]);

// Exports
exports.locals = {
	"container": "_32hzc",
	"empty": "p6mWy",
	"highQualityFrame": "_1nIt3",
	"lowQualityFrame": "_4tyZ-",
	"thumbText": "_24WRk"
};